import { po } from './po';
import { limitPerformanceTiming } from './state';

/**
 * Creates `first-input` performance observer to implement reporting of first input delay.
 * Also reports `lcp`, `cls`, `tbt`, `tbt5s`, `tbt10s`, and `tbtFinal` as a side effect
 *
 * @param {function} reportFn - Report callback for collection of statistics
 * @param {object} - metrics - Shared metrics to coordinate between performance observers
 * @returns {function} - disconnect function
 */
// eslint-disable-next-line import/prefer-default-export, @typescript-eslint/no-unused-vars
export function initFirstInputDelay(reportFn, metrics) {
  let isDisconnected = false;
  const fidObserver = po('first-input', performanceEntries => {
    const lastEntry = performanceEntries.pop();
    if (lastEntry) {
      // Measure the delay to begin processing the first input event (max of 5s)
      const inputDelayTime = lastEntry.processingStart - lastEntry.startTime;
      reportFn('fid', limitPerformanceTiming(inputDelayTime, 5000));
      // Measure when a user first starts interacting with site
      reportFn('fidStart', lastEntry.startTime);
    }
    // Disconnect this observer since callback is only triggered once
    fidObserver.disconnect();
  });

  // Return function to disconnect performance observers and clear any running timers
  return () => {
    if (!isDisconnected) {
      // `fidObserver` can be `false` if no browser support for observer type
      fidObserver && fidObserver.disconnect();

      // only need to execute this handler once
      isDisconnected = true;
    }
  };
}
//# sourceMappingURL=first-input-delay.js.map